import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import { FC } from 'react';

import ErrorMessage from 'components/ErrorMessage';

import ConfirmButton from 'primitives/ConfirmButton';

const WITHDRAW_UNIT_TRANSFER_REQUEST_MUTATION = gql(`
  mutation WithdrawUnitTransferRequest($id: ID!) {
    withdrawUnitTransferRequest(id: $id) {
      id
      status
    }
  }
`);

const WithdrawUnitTransferRequestButton: FC<{ requestId: string; onWithdrawn: () => void }> = ({
  requestId,
  onWithdrawn,
}) => {
  const [withdrawRequest, { loading, error }] = useMutation(
    WITHDRAW_UNIT_TRANSFER_REQUEST_MUTATION
  );

  return (
    <div>
      <ConfirmButton
        variant="secondary"
        title="Withdraw this transfer request?"
        description="This cannot be undone. You will need to raise a new request if you change your mind."
        confirmButtonLabel="Withdraw request"
        loading={loading}
        onConfirm={() =>
          withdrawRequest({ variables: { id: requestId } }).then(result => {
            if (result.data?.withdrawUnitTransferRequest) onWithdrawn();
          })
        }
      >
        Withdraw request
      </ConfirmButton>
      {error ? <ErrorMessage error={error} type="alert" /> : null}
    </div>
  );
};

export default WithdrawUnitTransferRequestButton;
